import { Observable } from 'rxjs';
import { CountryDropdownItem, TerritoriesState } from '@cpak/interfaces';

export abstract class CountriesTerritoriesAbstractService {
  public abstract getCountryState(): Observable<string>;
  public abstract updateCountryState(countryCode: string): void;
  public abstract getTerritoriesState(): Observable<TerritoriesState>;
  public abstract updateTerritoriesState(state: TerritoriesState): void;
  public abstract getAllCountries(): Observable<CountryDropdownItem[]>;
  public abstract getTerritories(countryCode: string): Observable<CountryDropdownItem[]>;
}
